import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onStartChatViaImAddressUrl = action('onStartChatViaImAddressUrl', event => ({
    event,
    owaType: 'startChatViaImAddressUrl',
})) as OwaNovaActionUnion<'startChatViaImAddressUrl'>;
